

export type TabPillItem = {
  label: string;
  active?: boolean;
};

export type TabPillsProps = {
  items: TabPillItem[];
  onChange?: (index: number) => void;
  className?: string;
};

const pillClass = (active: boolean) =>
  `flex-1 rounded-full px-4 py-2.5 text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus-ring)] active:scale-[0.98] ${
    active
      ? 'bg-[var(--bg-soft)] text-[var(--text)]'
      : 'text-[var(--text-muted)] hover:text-[var(--text)] hover:bg-[var(--bg-soft)]/50'
  }`;

export function TabPills({ items, onChange, className = '' }: TabPillsProps) {
  return (
    <div
      className={`mx-auto w-full max-w-md flex items-stretch gap-2 p-1 ${className}`}
      role="tablist"
    >
      {items.map((item, index) => (
        <button
          key={index}
          type="button"
          role="tab"
          aria-selected={item.active}
          className={pillClass(!!item.active)}
          onClick={() => onChange?.(index)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}